var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.routeGSheetID == 'TheDoctorIsGone')?_c('app-theDoctorIsGone',{attrs:{"roomID":_vm.$route.params.roomID}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }